export type IFlyerCarouselResources = typeof FlyerCarouselResources;

export const FlyerCarouselResources = {
    newFlyerLabel: "Nowa Gazetka",
};
